import React, { useEffect, useState } from 'react';
import SearchCoreModal, { SearchCoreProps } from './SearchCoreModal';
import { ShortUser, SystemAccessType, SystemAccessTypes } from '@arema/components/Classes';
import { useUser } from '../AdminHooks';
import API from '../API';

interface SearchUserModalProps extends SearchCoreProps<ShortUser>{
	systems?: SystemAccessType
}

var SearchUserModal = (props: SearchUserModalProps)=>{
	var { user } = useUser();
	return <SearchCoreModal
		title='Buscar usuario'
		{...props}
		searchData={(query, page, page_size)=>{
			return API.getUserList(query, page*page_size, 30, props.systems || { ADMIN: true });
			// return API.searchAdmin(query, page * page_size, page_size);
		}}
		onShowLoad={async ()=>{
			return {
				error: false,
				code: null,
				message: null,
				data: [{
					user_id: user.user_id,
					name: user.name,
					email: user.email,
				}]
			}
		}}
		pageSize={15}
		table={[
			{ name: 'ID', key: 'user_id', collapsing: true },
			{ name: 'Nombre', key: 'name', collapsing: true },
			{ name: 'Email', key: 'email' },
		]}
	/>
}

export default SearchUserModal;